//import './bootstrap';
import * as bootstrap from 'bootstrap5';
import 'fslightbox';
import Zangdar from 'zangdar/dist/zangdar.min';
import LuniMasonry from 'luni-masonry';

//------------------------ Botón Scroll Top ------------------------

let btnBackToTop = document.getElementById('btn-back-to-top');
window.onscroll = function () {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        btnBackToTop.style.display = 'block';
    } else {
        btnBackToTop.style.display = 'none';
    }
};
btnBackToTop.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});

//------------------------ /Botón Scroll Top ------------------------

//------------------------ Animaciones ------------------------

// Seleccionamos los elementos con el atributo data-anim
const animItems = document.querySelectorAll('[data-anim]')

const animateSingleElements = () => {

    // Definimos una función que se encargará de añadir la clase 'inView' cuando entren a la vista
    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inView')
            }
        })
    }

    // Definimos un objeto con las opciones que le pasaremos al IntersectionObserver
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    }

    // Creamos una instancia de IntersectionObserver con la función handleIntersection como callback
    const observer = new IntersectionObserver(handleIntersection, options)

    // Añadimos los elementos que queremos observar a la instancia de IntersectionObserver
    animItems.forEach(item => {
        observer.observe(item);
    })
}

const animItemsDelay = document.querySelectorAll('[data-anim-delay]');
if (animItemsDelay) {
    animItemsDelay.forEach(item => {
        //console.log(item.dataset.animDelay);
        item.style = 'transition-delay: ' + item.dataset.animDelay + 'ms';
    });
}

animateSingleElements();

//------------------------ /Animaciones ------------------------

//------------------------ Formulario Solicitud de Servicio de Acompañamiento ------------------------

const formWizard = document.getElementById('wizard');
if (formWizard) {
    function buildStepsBreadcrumb(wizard, element, steps) {
        const $steps = document.getElementById(element);
        $steps.innerHTML = '';
        const $alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        for (let label in steps) {
            if (steps.hasOwnProperty(label)) {
                const $li = document.createElement('li');
                const $a = document.createElement('a');
                let $iteration = steps[label].index + 1;
                $li.classList.add('nav-item');
                $a.classList.add('nav-link', 'nav-link-' + $iteration);
                if (steps[label].active) {
                    $a.classList.add('active');
                }
                $a.setAttribute('href', '#');
                $a.innerHTML = '<span class="numero"><span>' + $alphabet[steps[label].index] + '</span></span><span>' + label + '</span>';
                $a.addEventListener('click', e => {
                    e.preventDefault();
                    wizard.revealStep(label);
                })
                $li.appendChild($a);
                $steps.appendChild($li);
            }
        }
    }

    function onStepChange(wizard, selector) {
        const steps = wizard.getBreadcrumb();
        buildStepsBreadcrumb(wizard, selector, steps);
    }

    const wizard = new window.Zangdar('#wizard', {
        onStepChange: () => {
            onStepChange(wizard, 'steps-native');
        }
    })

    onStepChange(wizard, 'steps-native');
}

//------------------------ /Formulario Solicitud de Servicio de Acompañamiento ------------------------

//------------------------ Formulario Solicitud de Servicio ------------------------

const formRequestService = document.getElementById('formRequestService');
if (formRequestService) {
    const otcTypeRepresentation = document.getElementsByName('type');
    if (otcTypeRepresentation) {
        otcTypeRepresentation.forEach(item => {
            item.addEventListener('change', function () {
                const cardOwnRepresentation = document.getElementById('cardOwnRepresentation');
                const cardEntityRepresentation = document.getElementById('cardEntityRepresentation');
                if (this.id === 'type_2' && this.checked) {
                    cardOwnRepresentation.classList.add('d-none');
                    cardEntityRepresentation.classList.remove('d-none');
                } else {
                    cardEntityRepresentation.classList.add('d-none');
                    cardOwnRepresentation.classList.remove('d-none');
                }
            });
        });
    }
    const otcExistenceOther = document.getElementsByName('services[]');
    if (otcExistenceOther) {
        otcExistenceOther.forEach(item => {
            item.addEventListener('change', function () {
                const inputOtcExistenceOther = document.getElementById('services_other_label');
                if (this.id === 'services_8') {
                    if (this.checked) {
                        inputOtcExistenceOther.classList.remove('d-none');
                    } else {
                        inputOtcExistenceOther.classList.add('d-none');
                    }
                }
            });
        });
    }
}

//------------------------ /Formulario Solicitud de Servicio ------------------------

//------------------------ Vídeos Sección Difusión ------------------------

const diffusionVideos = document.querySelectorAll('.videos-difusion');
if (diffusionVideos) {
    diffusionVideos.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            item.querySelector('span').remove();
            item.querySelector('img').remove();
            item.querySelector('i').remove();
            item.innerHTML = '<div class="ratio ratio-16x9"><iframe class="rounded-top-4" src="https://www.youtube.com/embed/' + item.dataset.id + '" allowfullscreen></iframe></div>';
            item.classList.remove('videos-difusion');
        });
    });
}

if (document.getElementById('luni')) {
    const luni = new LuniMasonry({
        // active class
        active: 'is-activated',
        // in pixels
        margin: 20,
        // for responsive
        responsive: {
            1024: {
                columns: 3,
            },
            980: {
                columns: 3,
            },
            480: {
                columns: 2,
            },
            0: {
                columns: 1,
            },
        },
        // fade in/out duration
        fadeDuration: {
            in: 300,
            out: 50,
        },
    });
}

//------------------------ /Vídeos Sección Difusión ------------------------
